import { React } from "react";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { CONSTANTS } from "utils/constant";

const CommonButton = ({
  label,
  onClick,
  loading,
  disabled,
  className,
  htmlType,
  type,
  style
}) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      className={className}
      htmlType={htmlType}
      type={type}
      style={style}
    >
      {label}
      {label == "Save and Preview" || label == "Publish" || label == "Preview & Publish"? null : <ArrowRightOutlined />}
    </Button>
  );
};

export default CommonButton;
